export function normalizeTvActivationCode(value) {
  return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 12);
}

export function formatTvActivationCode(value) {
  const code = normalizeTvActivationCode(value);
  if (code.length <= 3) return code;
  return `${code.slice(0, 3)}-${code.slice(3)}`;
}

export async function approveTvDevice({ code, accessToken }) {
  const normalizedCode = normalizeTvActivationCode(code);
  if (!normalizedCode) throw new Error('Enter the activation code shown on your TV.');
  if (!accessToken) throw new Error('Sign in to WatchVIM before activating your TV app.');

  const formattedCode = formatTvActivationCode(normalizedCode);
  const response = await fetch('/api/tv/device/approve', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      code: normalizedCode,
      userCode: normalizedCode,
      user_code: normalizedCode,
      formattedCode,
    }),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.ok === false) {
    throw new Error(payload?.error || 'TV activation failed. Generate a new code on your TV and try again.');
  }
  return payload;
}
